module.exports = __webpack_public_path__ + "static/2005-layer-3-6409dd2dee1a31d537a82728719f46bc.png";